import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import CrownIcon from '@/assets/svg/credit/crown.svg';
import AlfabankIcon from '@/assets/svg/credit/alfabank.svg';
import CascoIcon from '@/assets/svg/credit/casco.svg';

import { CreditTagType, CreditTagsProps } from './types';

function CreditTags({ tags }: CreditTagsProps) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Component>
      {tags.map(({ currency, tagType }, index) => (
        <Tag key={index} currency={currency} tagType={tagType}>
          {currency ? (
            <React.Fragment>
              <Currency>{currency}</Currency>
              <Title currency={currency}>Валюта</Title>
            </React.Fragment>
          ) : tagType ? (
            <React.Fragment>
              {tagType === 'best-offer' && (
                <React.Fragment>
                  <Icon>
                    <CrownIcon />
                  </Icon>

                  <Title currency={currency} tagType={tagType}>
                    Лучшее предложение
                  </Title>
                </React.Fragment>
              )}

              {tagType === 'alfabank-approval' && (
                <React.Fragment>
                  <Icon>
                    <AlfabankIcon />
                  </Icon>

                  <Title currency={currency} tagType={tagType}>
                    Предодобрение
                  </Title>
                </React.Fragment>
              )}

              {tagType === 'casco' && (
                <React.Fragment>
                  <Icon>
                    <CascoIcon />
                  </Icon>

                  <Title currency={currency} tagType={tagType}>
                    КАСКО
                  </Title>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : null}
        </Tag>
      ))}
    </Component>
  );
}

export default CreditTags;

const Component = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Tag = styled.div<{
  tagType?: CreditTagType;
  currency?: string;
}>`
  display: flex;
  align-items: center;
  height: 28px;
  padding: 4px 8px;
  margin: 2.5px 5px 2.5px 0;
  border-radius: 28px;

  &:last-child {
    margin-right: 0;
  }

  ${({ currency }) =>
    currency &&
    css`
      background: ${colors.blue400};
    `}

  ${({ tagType }) =>
    tagType === 'best-offer'
      ? css`
          background: ${colors.orange300};
        `
      : tagType === 'alfabank-approval'
      ? css`
          border: 1px solid ${colors.red800_alpha50};
          padding: 3px 6px;
        `
      : tagType === 'casco'
      ? css`
          background: ${colors.aqua};
        `
      : ''}
`;

const Currency = styled.span`
  font-weight: 500;
  font-size: 10px;
  line-height: 20px;
  color: ${colors.main};
`;

const Title = styled.span<{
  tagType?: CreditTagType;
  currency?: string;
}>`
  font-size: 10px;
  line-height: 20px;
  margin-left: 4px;

  ${({ currency }) =>
    currency &&
    css`
      color: ${colors.main};
    `}

  ${({ tagType }) =>
    tagType &&
    css`
      color: ${tagType === 'best-offer'
        ? colors.orange200
        : tagType === 'alfabank-approval'
        ? colors.red800
        : tagType === 'casco'
        ? colors.aqua100
        : ''};
    `}
`;

const Icon = styled.div`
  width: 16px;
  height: 16px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
